export default __webpack_public_path__ + "static/media/Icons_Heart_Fill.add9cac2.svg";